import axios from 'axios'
import {Response} from './Common'
import env from '@//util/Env'
import {Vue} from 'vue/types/vue'

export default class User {
  public static setDiagnosisResult(pms: string, context: Vue) {
    context.$cookies.set(
      'ww.pms',
      pms,
      24 * 60 * 60, // 24h
      '/',
      env.CookieDomain,
      env.CookieDomain !== 'localhost',
      'Lax',
    )
  }
}
